import * as React from "react";

import SalesInsightsV2 from "../../../components/ShopOwner/SalesInsightsV2/SalesInsightsV2";

// Entry point for the redesigned Sales Insights (version 2) analytics screen.
// Replaces the old Statistics screen (kept but unlinked), mirroring how the
// inventory management module was moved to its v2 redesign.
const SalesInsightsV2Page: React.FC = () => {
  return <SalesInsightsV2 />;
};

export default SalesInsightsV2Page;
